module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/emptyCart.fc99cb28.svg";